import { FreeSpinsInfoEvent, SpinResponse } from '@cgs/data-access';
import { ResponseHolder } from '../response_holder';
import { BaseGameState } from '../states/base_game_state';
import { BaseGameRule } from './infra/base_game_rule';

export class StopToFreeSpins<TResponse extends SpinResponse> extends BaseGameRule<TResponse> {
  constructor(sourceState: BaseGameState<TResponse>, responseHolder: ResponseHolder<TResponse>) {
    super(sourceState, responseHolder);
  }

  ruleCondition(resp: ResponseHolder<TResponse>): boolean {
    return (
      !resp.curResponse.isBonus &&
      !resp.curResponse.isScatter &&
      !!resp.curResponse.freeSpinsInfo &&
      (resp.curResponse.freeSpinsInfo.currentFreeSpinsGroup?.name ===
        FreeSpinsInfoEvent.FreeFreeSpinsGroupName ||
        resp.curResponse.freeSpinsInfo.currentFreeSpinsGroup?.name ===
          FreeSpinsInfoEvent.PurchasedFreeSpinsGroupName) &&
      !(
        resp.curResponse.freeSpinsInfo.event === FreeSpinsInfoEvent.FreeSpinsStarted ||
        resp.curResponse.freeSpinsInfo.event === FreeSpinsInfoEvent.FreeSpinsAdded
      ) &&
      (resp.curResponse.freeSpinsInfo.currentFreeSpinsGroup?.count || 0) > 0
    );
  }
}
